import type { IconProps } from '../types/IconProps.ts';
export const Map: IconProps = {
    name: 'Map',
    children: [
        `<path d="m3 8 4.74-3.26a2 2 0 0 1 2.2-.04l4.12 2.6a2 2 0 0 0 2.2-.04L21 4M3 20l4.93-2.54a2 2 0 0 1 1.8-.01l4.3 2.11a2 2 0 0 0 1.77 0L21 17M21 4v13M3 8v12M9 5v12M15 8v11" />`,
    ]
};